import api from './api';

export interface CmsSite {
  id?: number | string;
  domain?: string;
}

/**
 * Fetch a signed preview URL from the backend.
 *
 * Uses the generate-preview-url API endpoint to get a time-limited
 * signed URL that works without JWT authentication.
 */
export const getSignedPreviewUrl = async (siteId: number | string, slug: string = 'index'): Promise<string> => {
  try {
    const response = await api.get<{ preview_url: string }>(`/api/cms/sites/${siteId}/generate-preview-url/?slug=${encodeURIComponent(slug)}`);
    return response.data.preview_url;
  } catch (error) {
    console.error('Failed to generate preview URL:', error);
    // Return a fallback URL that will show an error
    return `/cms/sites/preview/${slug === 'index' ? '' : slug}`;
  }
};

/**
 * Build a preview URL for a page slug.
 *
 * @deprecated Use getSignedPreviewUrl() for internal previews.
 * This function is kept for legacy/external domain-based previews only.
 */
export const buildPreviewUrl = (slug: string, site?: CmsSite): string => {
  const path = slug === 'index' ? '' : slug;

  // For sites with an ID, use the signed preview URL API instead
  // This sync function should only be used as a fallback
  if (site?.id) {
    console.warn('buildPreviewUrl is deprecated for internal previews. Use getSignedPreviewUrl() instead.');
  }

  // Fallback to domain-based URL (legacy/external preview)
  let base = site?.domain || window.location.origin;
  if (!/^https?:\/\//i.test(base)) {
    base = `https://${base}`;
  }
  base = base.replace(/\/$/, '');
  return `${base}/${path}?preview=1`;
};
